import 'https://unpkg.com/swiper@11/swiper-element-bundle.min.js';
import { toggleVisited, toggleMustTry } from './foodieProgress.js';
import { checkAndAwardBadges } from './badges.js';

const swiperOverlay = document.getElementById('swiper-overlay');
const gallerySwiperEl = document.getElementById('eatery-swiper');
const closeBtn = document.getElementById('close-swiper');
const loadingOverlay = document.getElementById('swiper-loading');

let isGalleryOpening = false;

closeBtn.addEventListener('click', () => {
  swiperOverlay.style.display = 'none';
  destroySwiper();
});

const DRUPAL_API_BASE = window.location.hostname.includes('localhost')
  ? 'http://localhost:8888'
  : 'https://ggcity.org';

function destroySwiper() {
  if (gallerySwiperEl.swiper) {
    gallerySwiperEl.swiper.destroy(true, true);
  }
  gallerySwiperEl.innerHTML = '';
}

async function fetchGalleryById(id) {
  const res = await fetch(`${DRUPAL_API_BASE}/api/fogg/restaurant/${id}`);
  if (!res.ok) throw new Error('Failed to fetch restaurant gallery');
  return await res.json();
}

function customSwiperReady(el) {
  return new Promise(resolve => {
    if (el.swiper) return resolve();
    el.addEventListener('swiperinit', () => resolve(), { once: true });
  });
}

/** Build info slide with hero + buttons */
async function buildInfoSlide(gallery) {
  const slide = document.createElement('swiper-slide');
  slide.classList.add('info-slide');
  
  const heroUrl =
    gallery.hero_image ||
    (Array.isArray(gallery.images) && gallery.images.length > 0 ? gallery.images[0] : '');
  const heroImg = document.createElement('img');
  heroImg.src = heroUrl;
  heroImg.classList.add('hero-image');
  
  const eateryTitle = document.createElement('h2');
  eateryTitle.textContent = gallery.title;
  
  const locationArea = document.createElement('div');
  locationArea.classList.add('address-area');
  locationArea.innerHTML = `
    <i class="fa-regular fa-location-dot"></i>
    <div class="address">${gallery.address}</div>
  `;
  
  const foodieActions = document.createElement('div');
  foodieActions.classList.add('eatery-actions');
  
  const placeId = gallery.id.toString();
  const { visited, mustTry } = await import('./foodieProgress.js').then(m => m.getFoodieProgress());
  
  const visitedBtn = document.createElement('button');
  visitedBtn.className = `visited-btn ${visited.includes(placeId) ? 'active' : ''}`;
  visitedBtn.dataset.placeId = placeId;
  visitedBtn.innerHTML = `
    <img src="/images/quests/unchecked.png" class="btn-icon off" />
    <img src="/images/quests/checked.png" class="btn-icon on" /> Visited
  `;
  
  const mustTryBtn = document.createElement('button');
  mustTryBtn.className = `must-try-btn ${mustTry.includes(placeId) ? 'active' : ''}`;
  mustTryBtn.dataset.placeId = placeId;
  mustTryBtn.innerHTML = `
    <img src="/images/quests/try-off.png" class="btn-icon off" />
    <img src="/images/quests/try-on.png" class="btn-icon on" />
    <div class="on">In my<br>Must Try!</div>
    <div class="off">Add to<br>Must Try!</div>
  `;
  
  foodieActions.appendChild(visitedBtn);
  foodieActions.appendChild(mustTryBtn);
  
  slide.appendChild(heroImg);
  slide.appendChild(eateryTitle);
  slide.appendChild(locationArea);
  slide.appendChild(foodieActions);
  
  return slide;
}  

function createImageSlide(imgUrl) {
  const slide = document.createElement('swiper-slide');
  slide.style.height = '100vh';
  slide.style.background = '#000';
  slide.style.display = 'flex';
  slide.style.alignItems = 'center';
  slide.style.justifyContent = 'center';

  const img = document.createElement('img');
  img.style.maxWidth = '100%';
  img.style.maxHeight = '100%';
  img.style.objectFit = 'contain';
  img.src = imgUrl;

  slide.appendChild(img);
  return slide;
}

async function openGallery(id) {
  if (isGalleryOpening) {
    console.log('Ignored duplicate openGallery call');
    return;
  }
  isGalleryOpening = true;

  destroySwiper();
  swiperOverlay.style.display = 'block';
  loadingOverlay.style.display = 'flex';

  try {
    const gallery = await fetchGalleryById(id);

    const infoSlide = await buildInfoSlide(gallery);
    gallerySwiperEl.appendChild(infoSlide);

    const images = Array.isArray(gallery.images) ? gallery.images : [];
    images.forEach(url => gallerySwiperEl.appendChild(createImageSlide(url)));

    const params = {
      injectStylesUrls: ['/stylesheets/fogg-expore.css'],
    }

    Object.assign(gallerySwiperEl,params);

    gallerySwiperEl.initialize();
    await customSwiperReady(gallerySwiperEl);
    gallerySwiperEl.swiper.update();
    gallerySwiperEl.swiper.slideTo(0, 0);
  } catch (err) {
    console.error('Error loading gallery:', err);
    alert('Failed to load this restaurant gallery.');
    swiperOverlay.style.display = 'none';
  } finally {
    loadingOverlay.style.display = 'none';
    isGalleryOpening = false;
  }
}

// Handle visited/mustTry button clicks
gallerySwiperEl.addEventListener('click', async e => {
  const visitedBtn = e.target.closest('.visited-btn');
  if (visitedBtn) {
    const placeId = visitedBtn.dataset.placeId;
    if (!placeId) return;
    try {
      const visited = await toggleVisited(placeId);
      console.log("✅ Visited toggled:", visited.length);
      console.log("👉 Calling checkAndAwardBadges with count:", visited.length);
      
      await checkAndAwardBadges(visited.length);

      visitedBtn.classList.toggle('active', visited.includes(placeId));
      document.dispatchEvent(new CustomEvent('visitedUpdated', { detail: { visited } }));
    } catch (err) {
      console.error('Error toggling visited:', err);
    }
    return;
  }

  const mustTryBtn = e.target.closest('.must-try-btn');
  if (mustTryBtn) {
    const placeId = mustTryBtn.dataset.placeId;
    if (!placeId) return;
    try {
      const list = await toggleMustTry(placeId);
      mustTryBtn.classList.toggle('active', list.includes(placeId));
      document.dispatchEvent(new CustomEvent('mustTryUpdated', { detail: { list } }));
    } catch (err) {
      console.error('Error toggling must try:', err);
    }
    return;
  }
});

// Expose globally
window.openGallery = openGallery;
